/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'annotate-cross': {
    width: 1,
    height: 1,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/><path pid="1" fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/>'
  }
})
